import { render } from "./Molde-Aberto.vue?vue&type=template&id=593b45fb&scoped=true"
import script from "./Molde-Aberto.vue?vue&type=script&lang=js"
export * from "./Molde-Aberto.vue?vue&type=script&lang=js"

import "./Molde-Aberto.vue?vue&type=style&index=0&id=593b45fb&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-593b45fb"]])

export default __exports__